module.exports = __webpack_public_path__ + "static/img/co.6caab0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/co.png
// module id = V7IS
// module chunks = 18